/** Último día hábil de febrero del año siguiente (Circular 082 de 2022). Febrero no tiene
 * festivos nacionales (Ley 51 de 1983), así que hábil es no sábado ni domingo. */
export function registroMintrabajoDeadline(periodYear: number): string {
  const fecha = new Date(Date.UTC(periodYear + 1, 2, 0))
  while (fecha.getUTCDay() === 0 || fecha.getUTCDay() === 6) fecha.setUTCDate(fecha.getUTCDate() - 1)
  return fecha.toISOString().slice(0, 10)
}
